import FlareVolumeTable from "./components/FlareVolumeTable";

const SetupFlareVolume = () => {
  return <FlareVolumeTable />;
};

export default SetupFlareVolume;
